import { render, staticRenderFns } from "./ServiceBigScreen.vue?vue&type=template&id=5cb6d322&scoped=true&"
import script from "./ServiceBigScreen.vue?vue&type=script&lang=js&"
export * from "./ServiceBigScreen.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBigScreen.vue?vue&type=style&index=0&id=5cb6d322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6d322",
  null
  
)

export default component.exports